import { Zalacznik } from "../../wspolne/zalacznik";

export class DodatkowyImportLokalizacjiModel {
    zalacznik: Zalacznik = new Zalacznik();
    projektId: string;
}